define([
    'text!fnjimedia-detail/component/main.html',
    'common/api',
    'jquery',
    'common/utils',


], function(
    tpl,Api,$,Utils
){
    return {
        template: tpl,
        data: function(){
            return {
                fnjiMedia: [],
            };
        },
        components: {
        },
        computed: {

        },
        created: function () {
            var obj = this;


        },
        methods: {
            init: function ()
            {
                var obj = this;

                Api.getFnjiMeida.ajax(
                    {
                        id: Utils.getUrlKey("id")
                    }).done(function (data)
                    {
                        obj.fnjiMedia = data.data;

                        obj.$nextTick(function(){
                            obj.initMasonry();
                        });
                        Utils.emitPageReady();

                    });
            },
            initMasonry:function ()
            {

                // var jQueryBridget = require('jquery-bridget');
                // var Masonry = require('masonry');
                // require(['jquery', 'masonry'], function($, _){
                // })
                // var Masonry = require('masonry');
                // require('imagesloaded');
                // var tab = require('imports-loader?$=jquery!imagesloaded');
                // var Masonry = require('imports-loader?$=jquery!masonry');
// // var msnry = new Masonry($(".media-list")[0],
//                 //     {
//                 //         itemSelector: 'li',
//                 //         gutter:0,
//                 //         isAnimated: true
//                 //     });
//
//                 // var jQueryBridget = require('jquery-bridget');
//                 // var Masonry = require('masonry-layout');
//                 // jQueryBridget( 'masonry', Masonry, $ );

                // imagesLoaded($(".media-list")[0], function( instance ) {
                //     var msnry = new Masonry($(".media-list")[0],
                //         {
                //             itemSelector: 'li',
                //             gutter:0,
                //             isAnimated: true
                //         });
                // });
                    //
                    // $(".media-list").imagesLoaded(function(){
                    //
                    //
                    // });

            }

        },
        mounted: function(){
            this.init();
        },






    };
});


//////////////////
// WEBPACK FOOTER
// ./fnjimedia-detail/component/main.js
// module id = 122
// module chunks = 4